import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Initialize Firebase
export const firebaseApp = (function () {
  const hostname = window.location.hostname;
  const isProduction = hostname === 'hire.upraised.co';
  const isStaging = hostname.startsWith('hire.staging.upraised.co');

  let firebaseConfig;
  if (isProduction) {
    firebaseConfig = {
      apiKey: 'AIzaSyDk9d6ESC_eClCQHkKm4fRFvdVx_bQRkIU',
      authDomain: 'hire-production.firebaseapp.com',
      projectId: 'hire-production',
      storageBucket: 'hire-production.appspot.com',
      messagingSenderId: '768282955535',
      appId: '1:768282955535:web:484df44b29d44208a2387a',
    };
  } else if (isStaging) {
    firebaseConfig = {
      apiKey: 'AIzaSyBgYOsYU2EoNqdLdxEq_jKe8vu4hd6F26M',
      authDomain: 'hire-staging.firebaseapp.com',
      projectId: 'hire-staging',
      storageBucket: 'hire-staging.appspot.com',
      messagingSenderId: '665443722487',
      appId: '1:665443722487:web:79c7eac467d129a0421ff2',
    };
  } else {
    firebaseConfig = {
      apiKey: 'AIzaSyAysWOEAnSu8532UFyggGsDbyGOTtHXS8o',
      authDomain: 'hire-development.firebaseapp.com',
      projectId: 'hire-development',
      storageBucket: 'hire-development.appspot.com',
      messagingSenderId: '956046233612',
      appId: '1:956046233612:web:1f1b960b5d07d36eaa1e29',
    };
  }
  return initializeApp(firebaseConfig);
})();

export const getFirebaseAuth = function () {
  const auth = getAuth(firebaseApp);
  return auth;
};
